export const GET_SETTING_GLOBAL_URL = 'GET_SETTING_GLOBAL_URL';

export const GET_SETTING_GLOBAL_URL_SUCCESS = 'GET_SETTING_GLOBAL_URL_SUCCESS';

export const GET_SETTING_GLOBAL_URL_FAILED = 'GET_SETTING_GLOBAL_URL_FAILED';